
export class PlayerIdValidator {

    public static isValid(playerId:String): boolean{
        return playerId && playerId !== undefined && playerId !== 'undefined';
    }

}
